export const BACKEND_URL = 'https://spiekeroog-backend.upcommerce.cloud/api';
export const APIKEY = '8ea90c5a2cce98fee7f99553d4c252e7';
export const R2_URL = 'https://spiekeroog-backend.upcommerce.cloud/api/r2api';
